import Box from '@mui/material/Box'
import { styled, SxProps } from '@mui/material/styles'
import Typography, { TypographyProps } from '@mui/material/Typography'
import React from 'react'

interface StyledTypoProps {
  fs?: number
  fw?: number
  c?: string
}

export const StyledTypo = styled((props) => (
  <Typography variant="h3" {...props} />
))(({ fs, fw, c }: StyledTypoProps) => ({
  fontSize: fs || 16,
  fontWeight: fw || 600,
  color: c,
  textAlign: 'inherit',
}))

export function CustomTypoContainer(props: any) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <StyledTypo {...props} />
    </Box>
  )
}

export function TypoContainer({
  children,
  sx,
}: {
  children: React.ReactNode
  sx?: SxProps
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        textAlign: 'center',
        ...sx,
      }}
    >
      {children}
    </Box>
  )
}

export default function CustomTypo(props: TypographyProps & StyledTypoProps) {
  return <StyledTypo {...props} />
}

export function CustomModalTypo(props: {
  children: React.ReactNode
  fs?: string | number
  fw?: number | string
  c?: string
  lh?: string
  ta?:
    | 'center'
    | 'left'
    | 'right'
    | 'justify'
    | 'inherit'
    | 'initial'
    | 'revert'
    | 'unset'
    | undefined
  o?: number
  m?: string
  w?: string | number
}) {
  return (
    <p
      className="md:w-[45%]"
      style={{
        fontFamily: 'Sora',
        fontStyle: 'normal',
        fontWeight: props.fw || 600,
        fontSize: props.fs || 16,
        lineHeight: props.lh || '24px',
        textAlign: props.ta || 'center',
        color: props.c || '#000000',
        opacity: props.o || 1,
        width: props.w || '100%',
        margin: props.m || '0 auto',
      }}
    >
      {props.children}
    </p>
  )
}
